import './styles/App.css';
import { useState, useEffect } from 'react';
import initialUnits from './data/initialUnits';
// Import pages
import StartUp from './pages/StartUp';
import SecretPin from './pages/SecretPin';
import Countdown from './pages/Countdown';
import Q1 from './pages/Q1';
import Q2 from './pages/Q2';
import Q3 from './pages/Q3';
import Q4 from './pages/Q4';
import Q5 from './pages/Q5';
import Q6 from './pages/Q6';
import Q7 from './pages/Q7';
import Q8 from './pages/Q8';
import Q9 from './pages/Q9';
import Q10 from './pages/Q10';
import Q12 from './pages/Q12';
import Q11 from './pages/Q11';
import Ready from './pages/Ready';
import LastPanel from './pages/LastPanel';
import FreakOut from './pages/FreakOut';

// Set to true to allow Left/Right arrow keys to move through Q pages
const ENABLE_KEYBOARD_Q_NAV = true;
const Q_NAV_TABS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10', 'q11', 'q12', 'freakout', 'lastpanel'];

function App() {
  // Load saved game state from localStorage
  const loadGameState = () => {
    try {
      const savedCredits = localStorage.getItem('planetIdle_credits');
      const savedUnits = localStorage.getItem('planetIdle_units');
      const savedQuestion = localStorage.getItem('planetIdle_question');
      const savedTotalQuestions = localStorage.getItem('planetIdle_totalQuestions');
      
      if (savedUnits) {
        const parsedUnits = JSON.parse(savedUnits);
        // Merge saved units with new units from initialUnits
        const mergedUnits = initialUnits.map(initialUnit => {
          const savedUnit = parsedUnits.find(u => u.id === initialUnit.id);
          return savedUnit || initialUnit;
        });
        
        return {
          credits: savedCredits ? parseFloat(savedCredits) : 50,
          units: mergedUnits,
          question: savedQuestion != null ? parseInt(savedQuestion, 10) : 1,
          totalQuestions: savedTotalQuestions != null ? parseInt(savedTotalQuestions, 10) : null
        };
      }
      
      return {
        credits: savedCredits ? parseFloat(savedCredits) : 50,
        units: initialUnits,
        question: savedQuestion != null ? parseInt(savedQuestion, 10) : 1,
        totalQuestions: savedTotalQuestions != null ? parseInt(savedTotalQuestions, 10) : null
      };
    } catch (error) {
      console.error('Error loading game state:', error);
      return { credits: 50, units: initialUnits, question: 1, totalQuestions: null };
    }
  };

  const initialState = loadGameState();
  const [credits, setCredits] = useState(initialState.credits);
  const [units, setUnits] = useState(initialState.units);
  const [question, setQuestion] = useState(initialState.question);
  const [totalQuestions, setTotalQuestions] = useState(initialState.totalQuestions);
  const [activeTab, setActiveTab] = useState('startup');

  // Calculate total production per second
  const totalProduction = units.reduce((sum, unit) => sum + (unit.count * unit.production), 0);

  // Save game state to localStorage whenever credits, units, or question change
  useEffect(() => {
    localStorage.setItem('planetIdle_credits', credits.toString());
    localStorage.setItem('planetIdle_units', JSON.stringify(units));
    localStorage.setItem('planetIdle_question', question.toString());
    if (totalQuestions != null) localStorage.setItem('planetIdle_totalQuestions', totalQuestions.toString());
  }, [credits, units, question, totalQuestions]);

  // Production tick (10 times per second for smooth updates)
  useEffect(() => {
    const interval = setInterval(() => {
      setCredits(prev => prev + totalProduction / 10);
    }, 100);
    return () => clearInterval(interval);
  }, [totalProduction]);

  // Keyboard back/forward through Q pages (only when ENABLE_KEYBOARD_Q_NAV is true)
  useEffect(() => {
    if (!ENABLE_KEYBOARD_Q_NAV) return;
    const idx = Q_NAV_TABS.indexOf(activeTab);
    if (idx === -1) return;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        if (idx > 0) {
          e.preventDefault();
          setActiveTab(Q_NAV_TABS[idx - 1]);
        }
      } else if (e.key === 'ArrowRight') {
        if (idx < Q_NAV_TABS.length - 1) {
          e.preventDefault();
          setActiveTab(Q_NAV_TABS[idx + 1]);
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeTab]);

  // Render the active page
  const renderPage = () => {
    switch (activeTab) {
      case 'startup':
        return <StartUp onEnter={() => setActiveTab('secretpin')} />;
      case 'secretpin':
        return <SecretPin onNavigate={setActiveTab} />;
      case 'countdown':
        return <Countdown onComplete={() => setActiveTab('q1')} />;
      case 'q1':
        return <Q1 onNavigate={setActiveTab} />;
      case 'q2':
        return <Q2 onNavigate={setActiveTab} />;
      case 'q3':
        return <Q3 onNavigate={setActiveTab} />;
      case 'q4':
        return <Q4 onNavigate={setActiveTab} />;
      case 'q5':
        return <Q5 onNavigate={setActiveTab} />;
      case 'q6':
        return <Q6 onNavigate={setActiveTab} />;
      case 'q7':
        return <Q7 onNavigate={setActiveTab} />;
      case 'q8':
        return <Q8 onNavigate={setActiveTab} />;
      case 'ready':
        return <Ready onNavigate={setActiveTab} />;
      case 'lastpanel':
        return <LastPanel onNavigate={setActiveTab} />;
      case 'freakout':
        return <FreakOut onNavigate={setActiveTab} />;
      case 'q9':
        return <Q9 onNavigate={setActiveTab} />;
      case 'q10':
        return <Q10 onNavigate={setActiveTab} />;
      case 'q11':
        return <Q11 onNavigate={setActiveTab} />;
      case 'q12':
        return <Q12 onNavigate={setActiveTab} />;
      default:
        return <StartUp onEnter={() => setActiveTab('secretpin')} />;
    }
  };

  return (
    <div className="app-container">
      {/* <NavMenu activeTab={activeTab} onTabChange={setActiveTab} /> */}
      {renderPage()}
    </div>
  );
}

export default App;
